import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { alignItems, strCode } from "../../../consts";
import { t } from "../../../services";

import { FlexContainers, WrapperContainer, AddButton } from "../../../components";
import LanguageItem from "./LanguageItem/LanguageItem";
import LanguageModal from "./LanguageModal";
import { LanguageListWrapper, LanguageSelectorWrapper } from "../styled";

const LanguageSelector = ({
  languageList,
  errorLangsList,
  selectedId,
  viewOnlyLangs,
  isEditDisabled,
  setSelectedId,
  onAddLanguage,
  onEditLanguage,
  onDeleteLanguage
}) => {
  const [languageModalActive, setLanguageModalActive] = useState(false);
  const [editedLanguage, setEditedLanguage] = useState();

  useEffect(() => {
    if (!languageModalActive) {
      setEditedLanguage(null);
    }
  }, [languageModalActive]);

  const onSave = (language) => {
    if (editedLanguage) {
      onEditLanguage({ id: editedLanguage?.id, language });
      setEditedLanguage(null);
    } else {
      onAddLanguage(language);
    }
  };

  return (
    <LanguageSelectorWrapper
      Container={FlexContainers.FlexColumn}
      alignItems={alignItems.start}
      gap={10}>
      <LanguageListWrapper
        Container={FlexContainers.FlexColumn}
        alignItems={alignItems.start}
        gap={10}
        width={223}
        pr={4}>
        {languageList?.length
          ? languageList.map((lang) => {
              return (
                <LanguageItem
                  key={lang.id}
                  id={lang.id}
                  title={lang.title}
                  isSelected={selectedId === lang.id}
                  isDeleteDisabled={languageList?.length === 1}
                  hasError={errorLangsList?.includes(lang.title)}
                  viewOnly={viewOnlyLangs?.includes(lang.title)}
                  onSelect={() => setSelectedId(lang.id)}
                  onEdit={() => {
                    setEditedLanguage(lang);
                    setLanguageModalActive(true);
                  }}
                  onDelete={() => onDeleteLanguage(lang.id)}
                />
              );
            })
          : null}
      </LanguageListWrapper>

      {!isEditDisabled && (
        <WrapperContainer Container={FlexContainers.FlexRow} height={40}>
          <AddButton
            onClick={() => {
              setLanguageModalActive(true);
            }}>
            {t(strCode.ADD_LANGUAGE_BTN)}
          </AddButton>
        </WrapperContainer>
      )}

      <LanguageModal
        active={languageModalActive}
        setActive={setLanguageModalActive}
        editedLanguage={editedLanguage?.title}
        selectedLanguages={languageList.map((lang) => lang.title)}
        onSave={onSave}
      />
    </LanguageSelectorWrapper>
  );
};

LanguageSelector.propTypes = {
  languageList: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number.isRequired, title: PropTypes.string.isRequired })
  ).isRequired,
  errorLangsList: PropTypes.arrayOf(PropTypes.string),
  selectedId: PropTypes.number.isRequired,
  isNewItem: PropTypes.bool,
  viewOnlyLangs: PropTypes.arrayOf(PropTypes.string).isRequired,
  isEditDisabled: PropTypes.bool,
  setSelectedId: PropTypes.func.isRequired,
  setIsNewItem: PropTypes.func,
  onAddLanguage: PropTypes.func.isRequired,
  onEditLanguage: PropTypes.func.isRequired,
  onDeleteLanguage: PropTypes.func.isRequired
};

export default LanguageSelector;
